const BAIL_TIMEOUT_MS = 5000;
const POLL_INTERVAL_MS = 100;

/**
 * Polls every 100ms until every
 * `td[data-column-index="0"]` visible within `scrollElement`'s viewport
 * has non-empty text content.
 *
 * Returns a cleanup function that cancels polling.
 *
 * @param scrollElement  The scroll container (from useScrollWindowRef).
 * @param onComplete     Called once with the elapsed ms when all visible
 *                       label cells have text.
 */
export function pollVisibleLabelCells(scrollElement, onComplete) {
  const start = performance.now();
  let pollTimer = 0;
  let bailTimer = 0;
  let done = false;
  const cleanup = () => {
    done = true;
    clearTimeout(pollTimer);
    clearTimeout(bailTimer);
  };
  const check = () => {
    if (done) return;
    const scrollRect = scrollElement.getBoundingClientRect();
    const labelCells = scrollElement.querySelectorAll('td[data-column-index="0"]');
    const visibleCells = [];
    for (const cell of labelCells) {
      const cellRect = cell.getBoundingClientRect();
      if (cellRect.top < scrollRect.bottom && cellRect.bottom > scrollRect.top) {
        visibleCells.push(cell);
      }
    }
    if (visibleCells.length > 0 && visibleCells.every(cell => {
      var _cell$textContent;
      return ((_cell$textContent = cell.textContent) !== null && _cell$textContent !== void 0 ? _cell$textContent : '').trim().length > 0;
    })) {
      onComplete(performance.now() - start);
      cleanup();
    } else {
      pollTimer = window.setTimeout(check, POLL_INTERVAL_MS);
    }
  };
  pollTimer = window.setTimeout(check, POLL_INTERVAL_MS);
  bailTimer = window.setTimeout(cleanup, BAIL_TIMEOUT_MS);
  return cleanup;
}